<template lang="pug">
  v-container
    v-card.sdo-card
      v-sheet(dark color="secondary").px-5.pt-4.pb-6.overflow-hidden
        v-list-item.pa-0(v-if="!loading")
          v-list-item-icon.ml-0
            v-progress-circular.mt-1(
              size="58" color="success" rotate="-90" value="65" width="10"
            )
              .text-caption: strong 4/6
          v-list-item-content
            .text-caption.mb-0 Наставляемый:
            h3( color="primary") Мванов Иван Иванович
            mentors-list(
              v-model="mentorId"
              :item="user"
              :chipProps="{ color: 'primary', small: true }"
              @change="changeMentor"
            )
          v-list-item-action.ma-0.ml-3
            v-btn(icon): v-icon mdi-chat
            p.text-caption Начало обучения:
              span.primary--text.text--lighten-4.ml-2: strong 14.04.2023
        v-row(no-gutters)
          v-col
            v-btn-toggle(v-model="tab")
              v-btn(
                color="#525164"
                :value="0"
              ).px-5
                v-icon(left) mdi-account
                span Рекомендации
              v-btn(
                color="#525164"
                :value="1"
              ).px-5
                v-icon(left) mdi-account
                span Календарь
              v-btn(
                color="#525164"
                :value="2"
              ).px-5
                v-icon(left) mdi-account-school-outline
                span Характеристика
          v-col(cols="auto").text-caption.align-self-end
            v-btn(rounded depressed large color="#525169") Порекомендовать
              v-icon(right size="28") mdi-plus
            //- span.text-caption Начало обучения:
            //-   span.primary--text.text--lighten-4.ml-2: strong 14.04.2023
      v-window(v-model="tab")
        v-window-item.pt-2.pb-6
          v-row(no-gutters)
            v-col(cols="8")
              v-card(flat)
                v-card-subtitle.py-0.text-caption Фильтрация:
                v-card-text
                  v-chip-group(
                    v-model="filters"
                    column
                    multiple
                    mandatory
                  )
                    chip-recommendation-type(
                      v-for="(type, idx) in types"
                      :type="type"
                      filter outlined
                      :key="idx"
                    )
                  data-wrapper(
                    :loading="loading"
                    :skeleton-items-count="4"
                    :has-items="false"
                    skeleton-type="paragraph"
                    :colsProps="{ cols: 12, md: 12, sm: 12, xl: 12 }"
                  )
                    template(#no-data)
                      v-alert(type="info" prominent text) Еще нет рекомендаций
            v-col.pr-2(cols="4")
              v-card.sdo-radius(
                outlined color="info"
                v-if="user && questionnaires.length"
              )
                .px-2.py-1.d-flex.align-center
                  span.text-body-2.ml-2.white--text: strong Направленные анкеты
                  v-spacer
                  v-icon.px-1(dark) mdi-ballot-outline
                v-list
                  v-list-item(
                    v-for="item in questionnaires"
                    @click="startQuestionnairesForm(item.questionnaireFormId, item.id)"
                    :disabled="item.isComplete"
                  )
                    v-list-item-action.mr-2.my-0(
                      v-if="item.questionnaireFormId "
                    ): v-icon(
                        left :color="item.isComplete ? 'success' : 'warning'"
                      ) {{ item.isComplete ? 'mdi-check' : 'mdi-progress-clock'}}
                    v-list-item-title(
                      :class="item.isComplete ? 'success--text' : 'primary--text'"
                      ).text-body-2 {{ item.name }}
                    v-list-item-action.my-0
                      v-icon(small color="primary" v-if="!item.isComplete") mdi-arrow-right
        v-window-item
        v-window-item
          v-card(flat)
            v-card-title.text-caption: strong Характеристика:
            v-card-text.px-6
              CInput.pa-2.text-body-2(placeholder="Заполните характеристику для наставляемого")
</template>
<script>
import DataWrapper from '@/components/DataWrapper.vue';
import CInput from '@/components/Constructor/CInput.vue';
import MentorsList from '../components/MentorsList.vue';
import ChipRecommendationType from '../components/chipRecommendationType.vue';

const types = ['program', 'practice', 'receipt'];

export default {
  components: {
    DataWrapper,
    CInput,
    MentorsList,
    ChipRecommendationType,
  },
  data() {
    return {
      filters: [0, 1, 2],
      types,
      tab: 0,
      user: null,
      mentorId: null,
      loading: true,
    };
  },
  computed: {
    questionnaires() {
      const { questionnaire_forms: forms, questionnaires } = this.user;
      return questionnaires.reduce((acc, cur) => {
        const {
          form_answers: answers = [],
          is_complete: isComplete,
          id: questionnaireFormId,
        } = forms.find(({ questionnaire_id: id }) => cur.id === id) || { };
        acc.push({
          ...cur, answers, isComplete, questionnaireFormId,
        });
        return acc;
      }, []);
    },
  },
  async created() {
    const params = {
      expand: 'user,role_name,id,questionnaire_forms,questionnaires,mentor,mentor_recommendations',
      'search[id]': this.$route.params.id,
    };
    const { data } = await this.$api.mentoring.requestList(this.$user.organization.id, params);
    [this.user] = data.data;
    this.mentorId = this.user.mentor.id;
    this.loading = false;
  },
  methods: {
    changeMentor(mentor) {
      this.$set(this.user, 'mentor_id', mentor.id);
      this.$set(this.user, 'mentor', mentor);
    },
  },
};
</script>
